/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Interval_Every_MonthsInputs */

const en_plan_interval_every_months = /** @type {(inputs: Plan_Interval_Every_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} months`)
};

const es_plan_interval_every_months = /** @type {(inputs: Plan_Interval_Every_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cada ${i?.count} meses`)
};

/**
* | output |
* | --- |
* | "Every {count} months" |
*
* @param {Plan_Interval_Every_MonthsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_every_months = /** @type {((inputs: Plan_Interval_Every_MonthsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_Every_MonthsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_every_months(inputs)
	return en_plan_interval_every_months(inputs)
});